import React from "react";
import RoleForm from "./RoleForm";

const AddRole = () => <RoleForm mode="create" />;

export default AddRole;
